import React from 'react';
import { UserAvatar } from '../../spa/core-components/Avatar';
import Pill from '@99designs/frontend-components/components/Pill/Pill';
import DisplayName from '@99designs/frontend-components/components/DisplayName/DisplayName';
import titleCase from '../../lib/titleCase';
import { profilePath } from '../../lib/platformUrls';
import TwoColumnContainer from '../TwoColumnContainer';
import AggregatedStarRating from '../AggregatedStarRating';
import VerticalSpacing from '../VerticalSpacing';
import Box from '../../spa/core-components/Box';

export interface Props {
    designerId: string;
    displayName: string;
    level?: 'TOP' | 'MID' | 'ENTRY';
    avgRating: number;
    totalRatings: number;
    ctaUrl?: string;
    isLinked?: boolean;
}

export default function AvatarWithDesignerMeta({
    designerId,
    displayName,
    level,
    avgRating,
    totalRatings,
    ctaUrl,
    isLinked,
}: Props) {
    return (
        <TwoColumnContainer
            variations={['inline', 'text-left-aligned']}
            colOne={
                <UserAvatar
                    userId={designerId}
                    size={'large'}
                    isLinked={isLinked}
                    userName={displayName}
                />
            }
            colTwo={
                <Box
                    paddingLeft="space7"
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    height="100%"
                >
                    <DisplayName
                        user={{ name: displayName, profileUrl: profilePath(designerId) }}
                        isLinked={isLinked}
                    />
                    {level && (
                        <>
                            <VerticalSpacing verticalSpacing="space4" />
                            <Box width="fit-content">
                                <Pill variations={[`${level.toLowerCase()}-level`]}>
                                    {titleCase(level)} Level
                                </Pill>
                            </Box>
                            <VerticalSpacing verticalSpacing="space5" />
                            <AggregatedStarRating
                                avgRating={avgRating}
                                totalRatings={totalRatings}
                                ctaUrl={ctaUrl}
                            />
                        </>
                    )}
                </Box>
            }
        />
    );
}
